import { render } from "./IssueStatusHelp.vue?vue&type=template&id=20b68e16&scoped=true"
import script from "./IssueStatusHelp.vue?vue&type=script&lang=js"
export * from "./IssueStatusHelp.vue?vue&type=script&lang=js"

import "./IssueStatusHelp.vue?vue&type=style&index=0&id=20b68e16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b68e16"]])

export default __exports__